/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getOnboardingSuggestedStarterPacksSkeleton.defs'
export { main as default } from './getOnboardingSuggestedStarterPacksSkeleton.defs'
